import type { PublicMarketingRoute } from './routes'
import { FREE_PLAN } from '../content/planMarketing'

export interface PageMeta {
  title: string
  description: string
}

export const PAGE_META: Record<PublicMarketingRoute, PageMeta> = {
  '/': {
    title: 'Pingscalate — Uptime monitoring with Slack and email alerts',
    description: `Monitor websites, APIs, SSL certificates, and domain expiry on a schedule. Public status pages, Slack and email alerts, and escalation policies. Free plan includes ${FREE_PLAN.monitors} monitors.`,
  },
  '/pricing': {
    title: 'Pricing — Pingscalate',
    description: `Simple, transparent uptime monitoring pricing. Start free with ${FREE_PLAN.monitors} monitors, public status pages, SSL/domain monitoring, and Slack and email alerts on every plan.`,
  },
  '/contact': {
    title: 'Contact — Pingscalate',
    description:
      'Get in touch with the Pingscalate team for support, billing questions, or product feedback.',
  },
  '/uptime-monitoring': {
    title: 'Uptime Monitoring — Pingscalate',
    description:
      'Learn what uptime monitoring is, why it matters for your business, and how Pingscalate keeps your sites online with scheduled checks, public status pages, and Slack or email alerts.',
  },
  '/slack-uptime-alerts': {
    title: 'Slack Uptime Alerts — Pingscalate',
    description:
      'Send website downtime alerts to Slack instantly. Connect your workspace, define escalation policies, and know when sites fail before users do.',
  },
  '/email-uptime-alerts': {
    title: 'Email Uptime Alerts — Pingscalate',
    description:
      'Send downtime and expiry alerts to email recipients on your escalation policies. Works alongside Slack alerts on every Pingscalate plan.',
  },
  '/public-status-pages': {
    title: 'Public Status Pages — Pingscalate',
    description:
      'Share uptime with customers on a branded public status page. Monitor lists, uptime charts, and real-time status—included on every Pingscalate plan.',
  },
  '/ssl-domain-monitoring': {
    title: 'SSL & Domain Expiry Monitoring — Pingscalate',
    description:
      'Get alerts before SSL certificates or domain registrations expire. Daily checks with Slack and email escalation on every Pingscalate plan.',
  },
  '/alternatives': {
    title: 'Pingscalate vs UptimeRobot, Better Stack & Pingdom',
    description:
      'Compare Pingscalate with other uptime monitoring tools. Slack and email alerts, public status pages, SSL/domain monitoring, and realistic checks for Cloudflare-protected sites.',
  },
  '/terms': {
    title: 'Terms of Service — Pingscalate',
    description: 'Terms of Service for the Pingscalate uptime monitoring platform.',
  },
  '/privacy': {
    title: 'Privacy Policy — Pingscalate',
    description: 'Privacy Policy for the Pingscalate uptime monitoring platform.',
  },
  '/refund': {
    title: 'Refund Policy — Pingscalate',
    description: 'Refund Policy for paid Pingscalate subscriptions.',
  },
  '/cookies': {
    title: 'Cookie Policy — Pingscalate',
    description: 'Cookie Policy for the Pingscalate website and application.',
  },
}

export const NOINDEX_ROUTES = new Set([
  '/login',
  '/signup',
  '/auth/confirm',
  '/status',
  '/status-pages',
  '/monitors',
  '/settings',
  '/admin',
])
